import {useEffect, useRef, useState} from 'react';
import {useAuth} from '../../../contexts/UserContext';
import {
  useRegistration,
  RegistrationContextProvider,
} from '../../../contexts/RegistrationContext';
import LabelWithInfo from '../../atoms/LabelWithInfo';

import styled from 'styled-components';
import config from '../../../config';
import {
  useParams,
  useNavigate,
  Link,
  Navigate,
  useLocation,
} from 'react-router-dom';
import {useApp} from '../../../contexts/AppContext';
import strings from '../../../strings';

const LogoSection = styled.div`
  height: 304px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${config.layout.wide} {
    height: 229px;
  }
`;

const ContentSection = styled.div`
  opacity: 1;
  transition: opacity 0.2s linear;

  &.hide {
    opacity: 0;
  }

  @media ${config.layout.wide} {
    max-width: 360px;
    margin: 0 auto;
  }
`;

const PageSmallTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
  min-height: 19px;

  span {
    font-size: 14px;
    line-height: 19px;
    font-weight: bold;
    @media ${config.layout.wide} {

    }
  }

  &:after {
    content: '';
    display: inline-block;
    width: 10px;
    height: 1px;
    background-color: #fff;
    opacity: 0.3;
    flex: 1 0 auto;
  }
`;

const DescriptionSection = styled.div`
  height: 134px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;
  line-height: 32px;

  &.step1 {
    height: 94px;
  }

  &.multiline {
    height: 150px;
  }

  & > div {
    white-space: pre-line;
  }

  @media ${config.layout.wide} {
    height: 155px;
    &.step1 {
      height: 134px;
    }
  }
`;

const ChoicesArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  a {
    text-decoration: none;
    color: #fff;
    height: 50px;
    line-height: 49px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    //padding: 0 30px;
    // width: 130px;/
    text-align: center;
    border-radius: 25px;
    font-weight: bold;
    font-size: 16px;
    padding: 0 50px;

    &.long {
      padding: 0 25px;
    }

    min-width: 130px;

    &.accent {
      background-color: rgba(255, 255, 255, 0.5);
    }

    &.in_touch {
      background-color: #ffffff;
      color: #000000;
      border-color: #ffffff;
    }

    @media (hover: hover) {
      transition: background-color 0.15s linear, border-color 0.15s linear, color 0.15s linear;
      &:hover {
        background-color: #ffffff;
        color: #000000;
        border-color: #ffffff;
      }
    }
  }
`;

const NoLink = styled.div`
  min-height: 50px;

  @media ${config.layout.wide} {
    min-height: 63px;
  }
`;

const LinkArea = styled.div`
  margin-top: 30px;
  margin-bottom: 40px;

  @media ${config.layout.wide} {
    margin-top: 40px;
    margin-bottom: 50px;
  }
`;

const LinkWrap = styled.div`

  text-align: center;

  span {
    display: block;
    font-size: 14px;
    line-height: 19px;
    font-weight: bold;
    margin-bottom: 17px;
  }

  a {
    font-size: 14px;
    line-height: 19px;
    font-weight: bold;
    color: #fff;
    text-decoration: underline;

    &.button {
      text-decoration: none;
      color: #fff;
      height: 36px;
      line-height: 35px;
      display: block;
      margin: 0 auto;
      border: 1px solid rgba(255, 255, 255, 0.5);
      //padding: 0 30px;
      width: 150px;
      text-align: center;
      border-radius: 18px;
      font-weight: bold;
      font-size: 14px;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5.875' height='10.185' viewBox='0 0 5.875 10.185'%3E%3Cpath id='パス_44' data-name='パス 44' d='M5.092,0l.783.783-4.31,4.31L5.875,9.4l-.783.783L0,5.092Z' transform='translate(0 0)' fill='%23ffffff'/%3E%3C/svg%3E%0A");
      background-position: 15px center;
      background-repeat: no-repeat;
      padding-left: 10px;

      &.in_touch {
        background-color: #ffffff;
        color: #000000;
        border-color: #ffffff;
      }

      @media (hover: hover) {
        transition: background-color 0.15s linear, border-color 0.15s linear, color 0.15s linear;

        &:hover {
          background-color: #ffffff;
          border-color: #ffffff;
          color: #000000;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5.875' height='10.185' viewBox='0 0 5.875 10.185'%3E%3Cpath id='パス_44' data-name='パス 44' d='M5.092,0l.783.783-4.31,4.31L5.875,9.4l-.783.783L0,5.092Z' transform='translate(0 0)' fill='%23000000'/%3E%3C/svg%3E%0A");
        }
      }
    }
  }
`;

const MiddleHR = styled.div`
  width: 100%;
  height: 1px;
  background-color: #fff;
  opacity: 0.3;
  margin-bottom: 72px;
  @media ${config.layout.wide} {
    margin-bottom: 63px;
  }
`;

const BackButtonArea = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 92px;

  a {
    text-decoration: none;
    color: #fff;
    height: 36px;
    line-height: 35px;
    display: block;
    border: 1px solid rgba(255, 255, 255, 0.5);
    //padding: 0 30px;
    width: 130px;
    text-align: center;
    border-radius: 18px;
    font-weight: bold;
    font-size: 14px;
    transition: background-color 0.15s linear, border-color 0.15s linear, color 0.15s linear;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5.875' height='10.185' viewBox='0 0 5.875 10.185'%3E%3Cpath id='パス_44' data-name='パス 44' d='M5.092,0l.783.783-4.31,4.31L5.875,9.4l-.783.783L0,5.092Z' transform='translate(0 0)' fill='%23ffffff'/%3E%3C/svg%3E%0A");
    background-position: 15px center;
    background-repeat: no-repeat;

    &.in_touch {
      background-color: #ffffff;
      color: #000000;
      border-color: #ffffff;
    }

    @media (hover: hover) {
      transition: background-color 0.15s linear, border-color 0.15s linear, color 0.15s linear;
      
      &:hover {
        background-color: #ffffff;
        color: #000000;
        border-color: #ffffff;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5.875' height='10.185' viewBox='0 0 5.875 10.185'%3E%3Cpath id='パス_44' data-name='パス 44' d='M5.092,0l.783.783-4.31,4.31L5.875,9.4l-.783.783L0,5.092Z' transform='translate(0 0)' fill='%23000000'/%3E%3C/svg%3E%0A");
      }
    }
  }
`;

const BackButton = styled.a`
  &:hover {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='5.875' height='10.185' viewBox='0 0 5.875 10.185'%3E%3Cpath id='パス_44' data-name='パス 44' d='M5.092,0l.783.783-4.31,4.31L5.875,9.4l-.783.783L0,5.092Z' transform='translate(0 0)' fill='%23ffffff'/%3E%3C/svg%3E%0A");
  }
`;

const KUVOIDDescription = styled.div`
  display: flex;
  margin-top: 15px;
  align-items: center;
  gap: 6px;
  position: relative;

  & > .label {
    font-size: 14px;
    position: relative;
    top: 1px;
  }
`;

const BASE_PATH = '/registration/wizard';

const CONTENTS = {
  1: {
    description: `Welcome to KUVO`,
    choices: [
      {
        label: 'SIGN UP',
        internal_link: true,
        path: `${BASE_PATH}/12`,
      },
    ],
    link: {
      static_label: `I already have an account.`,
      label: 'Skip to login',
      internal_link: true,
      button: true,
      path: `/registration`,
      state_callback: () => {
        return {
          add: 1,
        };
      },
    },
    back_button: false,
  },
  2: {
    description: `Do you have an AlphaTheta Account?`,
    choices: [
      {
        label: 'Yes',
        internal_link: true,
        path: `${BASE_PATH}/3`,
      },
      {
        label: 'No',
        internal_link: true,
        path: `${BASE_PATH}/7`,
      },
    ],
    link: null,
    back_button: true,
  },
  3: {
    description: `Did you create a KUVO account after October 2022?`,
    choices: [
      {
        label: 'Yes',
        internal_link: true,
        path: `${BASE_PATH}/5`,
      },
      {
        label: 'No',
        internal_link: true,
        path: `${BASE_PATH}/8`,
      },
    ],
    link: {
      label: 'I don’t remember',
      internal_link: true,
      path: `${BASE_PATH}/9`,
    },
    back_button: true,
  },
  5: {
    description: `Do you have a KUVO ID ?`,
    choices: [
      {
        label: 'Yes',
        internal_link: true,
        path: `${BASE_PATH}/6`,
      },
      {
        label: 'No',
        internal_link: true,
        path: `${BASE_PATH}/11`,
      },
    ],
    link: null,
    back_button: true,
  },
  6: {
    description: `You're all set!`,
    choices: [
      {
        label: 'Jump to login',
        internal_link: true,
        path: `/registration`,
        state_callback: () => {
          return {
            add: 1,
          };
        },
        accent_color: true,
      },
    ],
    link: null,
    back_button: true,
  },
  7: {
    description: `Create an AlphaTheta Account.`,
    choices: [
      {
        label: 'Jump to Pioneer DJ',
        internal_link: false,
        url: `${process.env.REACT_APP_PDJ_DOMAIN}/en/account/register/`,
        accent_color: true,
      },
    ],
    link: null,
    back_button: true,
  },
  8: {
    description: `Create a venue account.`,
    choices: [
      {
        label: 'Start registration',
        internal_link: true,
        path: `/registration`,
        accent_color: true,
      },
    ],
    link: null,
    back_button: true,
  },
  9: {
    description: `I don’t remember my account.`,
    choices: [
      {
        label: 'Contact us',
        internal_link: true,
        path: `/contact`,
        accent_color: true,
      },
    ],
    link: null,
    back_button: true,
  },
  11: {
    description: `I forgot my KUVO ID`,
    choices: [
      {
        label: 'Resend',
        internal_link: true,
        path: `/forgot-venue-code`,
        accent_color: true,
        state_callback: () => {
          return {
            from: {
              pathname: '/registration',
              search: window.location.search,
            },
          };
        },
      },
    ],
    link: null,
    back_button: true,
  },
  12: {
    description: `Is your venue located in UK, Netherlands or Australia?`,
    choices: [
      {
        label: 'Yes',
        internal_link: true,
        path: `${BASE_PATH}/15`,
      },
      {
        label: 'No',
        internal_link: true,
        path: `${BASE_PATH}/13`,
      },
    ],
    link: null,
    back_button: true,
  },
  13: {
    description: `Sorry, your territory is not in service yet.
    
    I want to sign up for the pilot!`,
    choices: [
      {
        label: 'Submit your name and email address',
        internal_link: false,
        url: 'https://kuvo.com/partnership-with-djmonitor/#form',
        accent_color: true,
      },
    ],
    link: null,
    back_button: true,
  },
  14: {
    description: `Sorry, your venue is currently not eligible to join KUVO.`,
    choices: [
      {
        label: 'About KUVO',
        internal_link: false,
        url: 'https://kuvo.com/',
        accent_color: true,
      },
    ],
    link: null,
    back_button: true,
  },
  15: {
    description: `Do you have a CDJ-3000, CDJ-3000X, or DJMonitor Go Device?`,
    choices: [
      {
        label: 'Yes',
        internal_link: true,
        path: `${BASE_PATH}/2`,
      },
      {
        label: 'No',
        internal_link: true,
        path: `${BASE_PATH}/14`,
      },
    ],
    link: null,
    back_button: true,
  },
};

export default function RegistrationWizardPage() {
  const auth = useAuth();
  const params = useParams();
  let step = params.step && parseInt(params.step, 10) || 1;
  const navigate = useNavigate();
  const location = useLocation();
  const [hiding, setHiding] = useState(false);

  if (!CONTENTS[step]) {
    step = 1;
  }
  const content = CONTENTS[step];
  console.log(step, hiding);

  useEffect(() => {
    window.blockAutoScroll();
    window.forceHeaderLink = false;
    let classList = document.getElementsByTagName('body')[0].classList;
    classList.remove('header');
    classList.remove('header-link');
    setHiding(false);
    document.title = 'Sign up';
    return () => {
      console.log('detached');
    };
  }, [step]);

  if (auth.isLoggedIn()) {
    return (
        <Navigate to={`/devices/${window.location.search}#new`} replace={true}/>
    );
  }

  document.getElementsByTagName('body')[0].classList.add('registration-wizard');

  let linkState = {};
  if (content.link?.state_callback) {
    linkState = content.link.state_callback();
  }

  return (
      <RegistrationContextProvider>
        <LogoSection>
          <div className={'sitelogo reverse'}/>
        </LogoSection>
        <ContentSection
            className={`${hiding ? 'hide' : ''}`}
        >
          <PageSmallTitle>
            {
              step == 1 ? '' : (<span>KUVO Set up</span>)
            }
          </PageSmallTitle>
          <DescriptionSection
              className={`${step == 1 ? 'step1' : ''} ${/\n/.test(
                  content.description) ? 'multiline' : ''}`}>
            <div>{content.description}
              {
                step == 5 ? (
                    <KUVOIDDescription>
                      <LabelWithInfo
                          data-wizard={1}
                          text={''}
                          labelclassname="kuvo-id-label"
                          style={{
                            marginLeft: -10,
                          }}
                      >
                        <div>
                          {strings.venue_code_ex}
                        </div>
                      </LabelWithInfo>
                      <div className={'label'}>KUVO ID</div>
                    </KUVOIDDescription>
                ) : ''
              }
            </div>

          </DescriptionSection>
          {
            content.choices.length ? (
                <ChoicesArea>
                  {
                    content.choices.map((c, i) => {
                      let state = {};
                      if (c.state_callback) {
                        state = c.state_callback();
                      }
                      if (c.internal_link) {
                        return (
                            <a
                                key={i}
                                href="#"
                                className={`in_touch_target ${c.accent_color
                                    ? 'accent'
                                    : ''} ${c.label.length > 15 ? 'long' : ''}`}

                                onClick={(e) => {
                                  e.preventDefault();
                                  if (/wizard/.test(c.path)) {
                                    setHiding(true);
                                    setTimeout(() => {
                                      navigate(
                                          c.path + `${window.location.search}`,
                                          {
                                            state,
                                          });
                                    }, 300);
                                  } else {
                                    navigate(
                                        c.path + `${window.location.search}`,
                                        {
                                          state,
                                        });
                                  }
                                  e.currentTarget.blur();
                                }}

                            >{c.label}</a>
                        );
                      } else {
                        return (
                            <a
                                key={i}
                                href={c.url} target={'_blank'}
                                className={`in_touch_target ${c.accent_color
                                    ? 'accent'
                                    : ''}  ${c.label.length > 15
                                    ? 'long'
                                    : ''}`}


                            >{c.label}</a>
                        );
                      }
                    })
                  }
                </ChoicesArea>
            ) : ''
          }

          {
            !content.link ? (<NoLink/>) : (
                <LinkArea>
                  <LinkWrap>
                    {
                      content.link.static_label ? (
                          <span>{content.link.static_label}</span>
                      ) : ''
                    }
                    {
                      content.link.internal_link ? (
                          <Link
                              to={content.link.path +
                                  `${window.location.search}`}
                              state={linkState}
                              className={`in_touch_target ${content.link.accent_color
                                  ? 'accent'
                                  : (content.link.button
                                      ? 'button'
                                      : '')}`}


                          >{content.link.label}</Link>
                      ) : (
                          <a href={content.link.url} target={'_blank'}
                             className={`in_touch_target ${content.link.accent_color
                                 ? 'accent'
                                 : ''}`}


                          >{content.link.label}</a>
                      )
                    }
                  </LinkWrap>
                </LinkArea>
            )
          }
          <MiddleHR/>
          {
            !content.back_button ? '' : (
                <BackButtonArea>
                  <BackButton className="in_touch_target back_button" href={'#'}
                              onClick={(e) => {
                                e.preventDefault();
                                setHiding(true);
                                setTimeout(() => {
                                  navigate(-1);
                                }, 300);
                              }}
                  >Back</BackButton>
                </BackButtonArea>
            )
          }
        </ContentSection>
      </RegistrationContextProvider>

  )
      ;
}